import {
  HeadingGroup,
  OffCanvasLayout,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import useRemittanceSettings from "./useRemittanceSettings";
import EmptyData from "../../Global/EmptyData";
import RemittanceSettingsForm from "./RemittanceSettingsForm";

const RemittanceSettings = () => {
  const {
    settingsData,
    tableData,
    isFetching,
    showEditModal,
    hasUpdatePermission,
    handleEditAction,
    closeEditModal,
    getRow,
    refetch,
  } = useRemittanceSettings();

  return (
    <>
      <HeadingGroup title={"Remittance Settings"} className={`pro-mb-4`} />
      <div className={`col-auto pro-pt-3 pro-pb-6`}>
        {tableData?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            data={tableData}
            uniqueID={"advance_payment_percentage"}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            showCheckBox={hasUpdatePermission}
            deletable={false}
            handleEdit={handleEditAction}
            assignable={false}
            multiSelect={false}
            fields={settingsData?.data?.fields}
            getRow={getRow}
            loading={isFetching}
          />
        )}

        <OffCanvasLayout
          show={showEditModal}
          handleClose={closeEditModal}
          title={"Update Remittance Settings"}
          closeIcon={<span className="material-symbols-outlined">close</span>}
          backdrop="static"
        >
          <RemittanceSettingsForm
            refetch={refetch}
            closeModal={closeEditModal}
            initialData={settingsData?.data?.data}
          />
        </OffCanvasLayout>

      </div>
    </>
  );
};

export default RemittanceSettings;
